// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5929) return "static/chunks/5929.b928fa49c8824417.js";
	if (chunkId === 4210) return "static/chunks/4210.224e6e897a82c168.js";
	if (chunkId === 1963) return "static/chunks/1963.f7c94f449fa8f41f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"155":"eb34e2d2f1b9b10b","1197":"a915c284eeb90656","1599":"d69ab647eb6c0c56","4115":"6fe289c41c62bba3","4159":"3c65a6674f4356f0","5110":"e74b022d922fbd5f","7256":"048dd9ee77f12f6f"}[chunkId] + ".js";
};